import androidx.compose.runtime.Composable
import com.svdsak.components.layout.PageLayout
import com.svdsak.components.sections.LandingComponent
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint

@Page("/")
@Composable
fun HomePage() {

    val breakpoint = rememberBreakpoint()
    PageLayout("Home") {
        Row(
            Modifier.fillMaxSize(),
            horizontalArrangement = Arrangement.Center,
            verticalAlignment = Alignment.CenterVertically
        ) {
            LandingComponent(breakpoint)
        }
    }

}